import { render, staticRenderFns } from "./Fleteros.vue?vue&type=template&id=6448e17b&scoped=true&"
import script from "./Fleteros.vue?vue&type=script&lang=ts&"
export * from "./Fleteros.vue?vue&type=script&lang=ts&"
import style0 from "./Fleteros.vue?vue&type=style&index=0&id=6448e17b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448e17b",
  null
  
)

export default component.exports